import { render, staticRenderFns } from "./pharmaceuticalexpo.vue?vue&type=template&id=96866d20&scoped=true"
import script from "./pharmaceuticalexpo.vue?vue&type=script&lang=js"
export * from "./pharmaceuticalexpo.vue?vue&type=script&lang=js"
import style0 from "./pharmaceuticalexpo.vue?vue&type=style&index=0&id=96866d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96866d20",
  null
  
)

export default component.exports